import { render, staticRenderFns } from "./top_btn.vue?vue&type=template&id=1ce7e8a0&"
import script from "./top_btn.vue?vue&type=script&lang=js&"
export * from "./top_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports